import { Link } from 'react-router-dom';

import { useT } from '../i18n/LanguageProvider';
import type { Insight } from '../types/content';

interface Props {
  insight: Insight;
}

export default function InsightCard({ insight }: Props) {
  const t = useT();

  return (
    <article className={insight.published ? 'insight-card' : 'insight-card is-planned'}>
      <span className="kicker">{insight.topic}</span>
      <h3>{insight.title}</h3>
      <p>{insight.excerpt}</p>
      <div className="card-foot">
        {insight.published ? (
          <Link className="textlink" to={`/insights/${insight.slug}`}>
            {t.common.readArticle}
          </Link>
        ) : (
          <span>{t.common.comingSoon}</span>
        )}
      </div>
    </article>
  );
}
